export default "__VITE_ASSET__B7j9NOlY__"